// Consumer data model fields

const FIELDS = {
    // System
    UID: 'UID',
    CREATED_DATE: 'createdDate',
    IS_REGISTERED: 'isRegistered',
    REGISTERED_DATE: 'registeredDate',
    IS_ACTIVE: 'profile.isActive',
    LAST_LOGIN_DATE: 'lastLoginDate',
    LAST_UPDATED_DATE: 'lastUpdatedDate',
    LAST_UPDATED_BY: 'lastUpdatedBy',
    // Profile
    FIRST_NAME: 'profile.firstName',
    LAST_NAME: 'profile.lastName',
    DATE_OF_BIRTH: 'profile.dateOfBirth',
    GENDER: 'profile.gender',
    EMAIL: 'profile.email',
    LANGUAGES: 'profile.languages',
    COUNTRY_CODE: 'profile.countryRefCode',
    // Phones
    MOBILE_NUMBER: 'profile.phones2.mobile',
    HOME_NUMBER: 'profile.phones2.home',
    MOBILE_VERIFICATION_STATUS: 'mobileVerification.status',
    MOBILE_VERIFICATION_DATE: 'mobileVerification.date',
    // Address - Personal
    ADDR_PERSONAL_TYPE: 'profile.address2.personal.type',
    ADDR_PERSONAL_COUNTRY: 'profile.address2.personal.country',
    ADDR_PERSONAL_CITY: 'profile.address2.personal.city',
    ADDR_PERSONAL_LINE1: 'profile.address2.personal.addressLine1',
    ADDR_PERSONAL_LINE2: 'profile.address2.personal.addressLine2',
    ADDR_PERSONAL_POSTAL: 'profile.address2.personal.postal',
    // Channel Opt-ins
    CHANNEL_OPT_EMAIL: 'consents.emailOptIn',
    CHANNEL_OPT_SMS: 'consents.smsOptIn',
    CHANNEL_OPT_CALL: 'consents.callOptin',
    CHANNEL_OPT_DM: 'consents.dmOptIn',
    // Brand Opt-ins
    BRAND_OPT_FLAG: 'consents.brandPreferences.optIn',
    BRAND_OPT_CHES: 'consents2.brands.chesterfield',
    BRAND_OPT_MARL: 'consents2.brands.marlboro',
    // Brand segmentation
    BRAND_FAMILY: 'favouriteBrand.brandFamily',
    BRAND_FAMILY_ID: 'favouriteBrand.brandFamilyId',
    BRAND_SUB_FAMILY: 'favouriteBrand.brandSubFamily',
    BRAND_SUB_FAMILY_ID: 'favouriteBrand.brandSubFamilyId',
    // HAV
    HAV_LAST_UPD_DATE: 'hav.hardAVLastUpdatedDate',
    HAV_COUNTRY_CODE: 'hav.hardAVCountryRefCode',
    HAV_TYPE: 'hav.hardAVType',
    HAV_STATUS: 'hav.hardAVStatus',
};

const GROUPS = {
    ADDR_PERSONAL: [
        FIELDS.ADDR_PERSONAL_TYPE,
        FIELDS.ADDR_PERSONAL_COUNTRY,
        FIELDS.ADDR_PERSONAL_CITY,
        FIELDS.ADDR_PERSONAL_LINE1,
        FIELDS.ADDR_PERSONAL_LINE2,
        FIELDS.ADDR_PERSONAL_POSTAL,
    ],
    BRAND_OPT_INS: [FIELDS.BRAND_OPT_CHES, FIELDS.BRAND_OPT_MARL],
    BRAND_SEGMENTATION: [
        FIELDS.BRAND_FAMILY,
        FIELDS.BRAND_FAMILY_ID,
        FIELDS.BRAND_SUB_FAMILY,
        FIELDS.BRAND_SUB_FAMILY_ID,
    ],
};

export { FIELDS, GROUPS };
